import React, { useState } from 'react'
import styled from 'styled-components';

import { useAuthService } from '../Context/AuthContext';
import LocalStorage from "../Helpers/LocalStorage";
import { useTranslate, useTolgee } from '@tolgee/react';
import { ReactComponent as NavLogo } from "../Assets/icons/landingPage/nav-logo.svg"
import PrimaryButton from '../Components/GenericComponents/PrimaryButton';

import LanguageBtn from '../Components/Auth Components/LanguageBtn';
import { ReactComponent as SmallChat } from "../Assets/icons/small-chats-icons.svg";
import { ReactComponent as Globe } from "../Assets/iconsv2/sidebar/GlobeIcon.svg"
import { INTERFACE_TRANSLATION_LANGUAGES } from '../Constants/constantValues';


const QuickChatDetailsPage = ({ handleContinue, name, setName, language, setLanguage, quickChat }) => {

    const { translationsLanguages } = useAuthService();
    const { t } = useTranslate();
    const tolgee = useTolgee();
    const [interfaceLanguage, setInterfaceLanguage] = useState(tolgee.getLanguage());

    return (
        <FirstWrapper>
            <LogoWrapper>
                <NavLogo />
                <DecorationLine />
            </LogoWrapper>

            <Content>


                <TitleWrapper>
                    <Title>{t('quick_chat.invited_by')} <span>'{quickChat.quick_chat_name}'</span> {t('quick_chat.emotii_chat')}!</Title>
                    <Subtitle>{t('quick_chat.enter_name_and_language')}</Subtitle>
                </TitleWrapper>


                <Group>
                    <Group>
                        <GroupDescription>
                            <GroupDescriptionText>{t('general.interface_language')}</GroupDescriptionText>
                        </GroupDescription>
                        <LanguageBtn
                            value={interfaceLanguage }
                            setValue={(value) => {
                            setInterfaceLanguage(value);
                            tolgee.changeLanguage(value);
                            LocalStorage.setInterfaceLanguage(value);
                            }}
                            valuesList={INTERFACE_TRANSLATION_LANGUAGES}
                            placeholder={
                            t('general.interface_language_placeholder')
                            }
                            placeholderIcon={<Globe />}
                            callLanguage
                        />
                    </Group>
                    <Group >
                        <GroupDescription>
                            <GroupDescriptionText>{t('register.chat_language')}</GroupDescriptionText>
                        </GroupDescription>
                        <LanguageBtn
                            value={language}
                            setValue={setLanguage}
                            valuesList={translationsLanguages}
                            placeholder={
                                t('register.chat_language_placeholder')
                            }
                            placeholderIcon={<SmallChat />}
                        />
                    </Group>
                    <Group >
                        <GroupDescription>
                            <GroupDescriptionText>{t('general.your_name')}</GroupDescriptionText>
                        </GroupDescription>
                        <CustomInputWrapper>
                            <input
                                placeholder={t('register.name_placeholder')}
                                onChange={(e) => setName(e.currentTarget.value)}
                                value={name}
                                name='name'
                                maxLength={100}
                            />
                        </CustomInputWrapper>
                    </Group>
                    <Group>
                        <PrimaryButton
                            style={{ padding: "16px" }}
                            disabled={!language || name === ""}
                            onClick={(e) => handleContinue(e)}
                            text={t('register.next_button')}
                        >
                        </PrimaryButton>
                    </Group>
                </Group>

            </Content>

        </FirstWrapper>
    )
}

export default QuickChatDetailsPage

const FirstWrapper = styled.div`
display:flex;
flex-direction:column;
width:100%;
height:100svh;
overflow:hidden;
background:${({ theme }) => theme.menu.background};
margin:0 auto;
padding:20px 0;
  @media (max-width: 1440px) {
    margin: 0;
    padding: 0;
  }

`;


const Content = styled.div`
max-width: 800px;
display:flex;
flex-direction:column;
justify-content:center;
width:100%;
height:100%;
padding:20px;
margin:auto;
gap:30px;
overflow:auto;
@media(max-width:990px){
justify-content:start;
}
`

const TitleWrapper = styled.div`
display:flex;
flex-direction:column;
gap:8px;
`
const Title = styled.h1`
color:${({ theme }) => theme.menu.primaryTextColor};
font-size: 24px;
font-weight: 400;
line-height: 30px;
span{
    font-weight: 700;
}
@media(max-width:990px){
    font-size: 20px;
    line-height: 25px;
}
`
const Subtitle = styled.p`
color:${({ theme }) => theme.menu.primaryTextColor};
opacity:0.5;
font-size: 16px;
font-weight: 400;
line-height: 30px;

`

const Group = styled.div`
display:flex;
flex-direction:column;
gap:20px;
width:100%;

`
const GroupTitle = styled.h1`
color:${({ theme }) => theme.menu.primaryTextColor};
font-size: 22px;
font-weight: 500;
line-height: 28px;
text-align: left;
@media(max-width:990px){
    font-size: 20px;
    line-height: 28px;
}
`

const GroupDescription = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const GroupDescriptionText = styled.p`
    color:${({ theme }) => theme.menu.secondaryTextColor};
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    letter-spacing: 0px;
    text-align: left;
`;

const CustomInputWrapper = styled.div`
 display: flex;
 width:100%;
input {
     width:100%;
    padding: 14px 16px;
    color: ${({ theme }) => theme.menu.primaryTextColor};
    background: ${({ theme }) => theme.menu.groupContentBackground};
    border-radius: 4px;
    border: none;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    &:focus {
      outline: none;
    }
  }
`

const LogoWrapper = styled.div`
display:flex;
flex-direction:column;
width:100%;
max-width: 1600px;
margin:0 auto;
gap:20px;
padding:20px;
svg{
color:white;
}


`

const DecorationLine = styled.div`
min-height:3px;
max-width:150px;
min-width:150px;
background:${({ theme }) => theme.menu.selectedTextColor};
`